import { render, staticRenderFns } from "./HighlightedMessageWidgetPreview.vue?vue&type=template&id=102a6544"
import script from "./HighlightedMessageWidgetPreview.vue?vue&type=script&lang=js"
export * from "./HighlightedMessageWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports